import React from 'react'
import { ReactComponent as CheckIcon } from 'containers/groupAppPricing/groupAppPlan/icons/check.svg';

import styles from './CheckMarkIcon.module.scss'

const CheckMarkIcon = ({ themeColor, executeFn, type }: { themeColor?: string, executeFn?: any, type?: string }) => {
    return (
        <div
            onClick={() => executeFn && executeFn()}
            className={`${styles.CheckMarkIcon} ${type === 'checkbox' ? styles.checkbox : ''}`}
            style={{
                backgroundColor: themeColor,
                border: `1px solid ${themeColor}`,
            }}
        >
            {
                themeColor && <CheckIcon />
            }
        </div>
    )
}

export default CheckMarkIcon